import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Home from '@/views/Home'
import Plan from '@/views/home/Plan'
import State from '@/views/home/State'
import Grade from '@/views/home/Grade'
import Profile from '@/views/home/Profile'
import Setting from '@/views/home/Setting'
import RequestGrade from '@/views/home/RequestGrade'

import Login from '@/views/pages/Login'

import Store from '@/store'
import Aggregate from '@/views/home/Aggregate'
import UserInfo from '@/views/home/UserInfo'
import UserInfoLog from '@/views/home/UserInfoLog'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

Vue.use(Router)
Vue.use(VueMaterial)

var router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/login', name: 'Login', component: Login },
    {
      path: '/',
      redirect: '/Home',
      name: ' ',
      component: Full,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'Home',
          name: 'Home',
          component: Home
        },
        {
          path: 'Plan',
          name: '物件管理',
          component: Plan
        },
        {
          path: 'State',
          name: '利用状況',
          component: State
        },
        {
          path: 'Grade',
          name: 'コース変更',
          component: Grade
        },
        {
          path: 'RequestGrade',
          name: 'アップグレード申し込み',
          component: RequestGrade
        },
        {
          path: 'Profile',
          name: 'プロフィール',
          component: Profile
        },
        {
          path: 'Setting',
          name: '設定',
          component: Setting
        },
        {
          path: 'Aggregate',
          name: '集計',
          component: Aggregate
        },
        {
          path: 'UserInfo',
          name: '利用者情報',
          component: UserInfo,
          props: true
        },
        {
          path: 'UserInfoLog',
          props: true,
          name: '利用者ログ情報',
          component: UserInfoLog
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (Store.state.loggedIn === null) {
    Store.commit('initializeStore')
  }
  if (to.matched.some(record => record.meta.requiresAuth) && !Store.state.loggedIn) {
    next({
      path: 'login', query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js